import React, { useEffect, useState } from "react";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import bankingService from "../../../components/Services/banking.service";
import { Accordion } from "react-bootstrap";
import NodataFound from "../../../commons/Toast/noDataFound";
import BankingLedger from "./bankingLedger";
import { CircularProgress } from "@mui/material";
import { disableButton, enableButton } from "../../../store/ButtonFlag/actions";
import ReceivedBankingRequests from "./receivedBankingRequests";
import { useDispatch, useSelector } from "react-redux";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import documentUploadService from "../../../components/Services/documentUpload.service";
import { toast } from "react-toastify";
import { toastProperties } from "../../../commons/Toast/Toaster";
import AgreementModel from "../../../components/AgrIndModel/AgreementModel";
import InfoExcangeModal from "../../../components/InfoExchangeModal/InfoExcangeModal";

const LedgerPage = () => {
  const [ledgerListingData, setLedgerListingData] = useState();
  const [loader, setLoader] = useState(true);
  const [isReceivedBankModal, setIsReceivedBankModal] = useState(false);
  const dispatch = useDispatch();
  const configKey = useSelector((state) => state?.sessionState?.connectionName);
  const isButtonEnabled = useSelector(
    (state) => state?.buttonReducer?.isButtonEnabled
  );

  const [docType, setDocType] = useState("");
  const [docOpen, setDocOpen] = useState(false);
  const [docData, setDocData] = useState({});

  const [infoModal, setInfoModal] = useState(false);
  const [infoData, setInfoData] = useState({});

  const getBankingLedger = () => {
    bankingService.getBankingLedger().then((response) => {
      if (response?.data?.code === 200) {
        setLoader(false);
        setLedgerListingData(response?.data?.data);
      } else if (response?.data?.code !== 200) {
        setLoader(false);
      }
    });
  };
  const handleViewConnection = (e, item) => {
    e.stopPropagation();
    disableButton()(dispatch);
    let connectionId = item?.bankingListingId;
    let connectionAgainstId = item?.againstBankingListingId;
    bankingService
      .viewSentBankingConnection(connectionId, connectionAgainstId)
      .then((response) => {
        if (response?.data?.code === 200) {
          setIsReceivedBankModal(response?.data?.data);
          enableButton()(dispatch);
        } else if (response?.data?.code !== 200) {
          enableButton()(dispatch);
        }
      })
      .catch((err) => {
        console.log("Api Call Error:", err);
        enableButton()(dispatch);
      });
  };
  const closeViewConnectionModal = () => {
    setIsReceivedBankModal(false);
  };
  useEffect(() => {
    getBankingLedger();
  }, []);

  const handleClose = () => {
    setDocOpen(false);
  };

  const handleOpenDoc = ({ data, type }) => {
    setDocType(type);
    setDocData(data);
    setTimeout(() => {
      setDocOpen(true);
    }, 2000);
  };

  const handleAgreement = (e, data) => {
    e.stopPropagation();
    handleOpenDoc({
      data,
      type: "AGREEMENT",
    });
  };

  const handleLoi = (e, data) => {
    e.stopPropagation();
    handleOpenDoc({
      data,
      type: "LOI",
    });
  };

  const handleOpenInfoModal = (e, data) => {
    e.stopPropagation();
    setInfoData(data);
    setTimeout(() => {
      setInfoModal(true);
    }, 1000);
  };

  return (
    <>
      {infoModal && (
        <InfoExcangeModal
          open={infoModal}
          handleClose={() => setInfoModal(false)}
          data={infoData}
        />
      )}
      {docOpen && (
        <AgreementModel
          type={docType}
          handleClose={handleClose}
          open={docOpen}
          dataL={docData}
        />
      )}
      {isReceivedBankModal && (
        <ReceivedBankingRequests
          isOpen={isReceivedBankModal}
          closeReceivedBankModal={closeViewConnectionModal}
          getBankingLedger={getBankingLedger}
        />
      )}
      {loader ? (
        <div className="popup-background">
          <CircularProgress />
        </div>
      ) : (
        <div className="" style={{ margin: "50px 16px" }}>
          <Accordion defaultActiveKey="0">
            {ledgerListingData?.length > 0 ? (
              ledgerListingData?.map((item, i) => (
                <Accordion.Item key={i} eventKey={i}>
                  <Accordion.Header>
                    <div
                      style={{
                        width: "80%",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div className="d-grid  justify-content-center">
                        <div className="d-flex gap-2">
                          <h6>My Listing :</h6>
                          <div className="bold-text">
                            {item?.bankingListing?.name}
                          </div>
                          <div>
                            Quantity(MW) :
                            <span className="bold-text">
                              {item?.bankingListing?.requiredQty} MW
                            </span>
                          </div>
                          <div className="small">
                            Expires on {item?.bankingListing?.expiryAt}
                          </div>
                        </div>

                        <div className="d-flex gap-2">
                          <h6>Discom Listing :</h6>
                          <div className="bold-text">
                            {item?.againstBankingListing?.name}
                          </div>
                          <div>
                            Quantity(MW) :
                            <span className="bold-text">
                              {item?.againstBankingListing?.requiredQty} MW
                            </span>
                          </div>
                          <div className="small">
                            Expires on {item?.againstBankingListing?.expiryAt}
                          </div>
                        </div>
                      </div>
                      <div style={{ display: "flex", gap: "16px" }}>
                        <button
                          className="d-flex btn btn-login"
                          onClick={(e) => handleViewConnection(e, item)}
                          disabled={isButtonEnabled}
                        >
                          {/* <RemoveRedEyeIcon style={{ height: "25px", width: "25px" }} /> */}
                          <div style={{ textTransform: "capitalize" }}>
                            View {configKey}
                          </div>
                        </button>
                        <div style={{ display: "flex", gap: "16px" }}>
                          <div
                            className="d-flex btn btn-login"
                            onClick={(e) => handleOpenInfoModal(e, item)}
                          >
                            Information Exchanges
                          </div>
                          <div
                            className="d-flex btn btn-login"
                            onClick={(e) => handleLoi(e, item)}
                          >
                            Letter of Intent
                          </div>
                          <div
                            className="d-flex btn btn-login"
                            onClick={(e) => handleAgreement(e, item)}
                          >
                            Agreement
                          </div>
                        </div>
                      </div>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <BankingLedger
                      data={item}
                      getBankingLedger={getBankingLedger}
                    />
                  </Accordion.Body>
                </Accordion.Item>
              ))
            ) : (
              <NodataFound />
            )}
          </Accordion>
        </div>
      )}
    </>
  );
};

export default LedgerPage;
